/** Utah's words for returntowork.ts. */
export const RETURNTOWORK_UT = {
  /** Citation part: Utah's illness reporting amendment to Food Code 8-501.10(C) (R386-702). */
  illnessAmendCite: "8-501.10(C) (Utah amendment, R386-702)",
} as const;
